import styled from 'styled-components';

export const Paragraph = styled.p`
  font-size: 20px;
  margin-bottom: 5px;
`;

export const FilterDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
`;

export const FilterInput = styled.input`
  width: 50%;
  height: 30px;
  border-radius: 5px;
  border: none;
  padding: 5px 10px;
`;
